export default "__VITE_ASSET__5bf61445__"